module.exports = "<h1>Welcome to Inventory Dashboard</h1>"